"use client"

import { Globe } from "lucide-react"

import { locales, type Locale } from "@shared/i18n"
import { Button } from "@shared/ui/components/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@shared/ui/components/dropdown-menu"

import { setLocaleClient, useLocale, useTranslations } from "@/lib/i18n/client"

export function LocaleSwitcher() {
  const t = useTranslations("locale")
  const currentLocale = useLocale()

  function handleChange(locale: Locale) {
    if (locale === currentLocale) return
    void setLocaleClient(locale)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={t(currentLocale)}
          />
        }
      >
        <Globe className="size-4" />
        <span className="hidden sm:inline">{t(currentLocale)}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {locales.map((locale) => (
          <DropdownMenuItem
            key={locale}
            onClick={() => handleChange(locale)}
            className={locale === currentLocale ? "font-medium" : undefined}
          >
            {t(locale)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
